export enum Causes {
    FetchException = 'FetcException',
    HandlerRaisedException = 'HandlerRaisedException',
    UnhandledStatus = 'UnhandledStatus',
    AccessTokenExpired = 'AccessTokenExpired',
}

export interface HttpError {
    status?: number;
    statusText?: string;
    message?: string;
    'request-id'?: string;
    cause?: Causes;
    method?: string;
    url?: string;
}

export enum ActionTypes {
    SetUnhandledHttpError = '[error] SET_UNHANDLED_HTTP_ERROR',
    ClearErrors = '[error] CLEAR_ERRORS',
}

export interface SetError {
    type: ActionTypes.SetUnhandledHttpError;
    payload: HttpError;
}

export function setError(
    cause?: Causes,
    status?: number,
    statusText?: string,
    message?: string,
    requestId?: string,
    url?: string,
    method?: string
): SetError {
    return {
        type: ActionTypes.SetUnhandledHttpError,
        payload: {
            cause,
            status,
            statusText,
            message,
            'request-id': requestId,
            method,
            url,
        },
    };
}

interface ClearErrors {
    type: ActionTypes.ClearErrors;
}

export function clearErrors(): ClearErrors {
    return {
        type: ActionTypes.ClearErrors,
    };
}

export type Actions = SetError | ClearErrors;
